export default "__VITE_ASSET__CL5IHzqD__"